export default __webpack_public_path__ + "static/media/leave.3a8ad3de.mp3";